<template>
  <div class="accordion" ref="default">
    <slot v-if="!baseData.length"></slot>
    <div v-else >
      <div v-for="(item,index) in baseData" :key="`faq-${index}`" class="accordion__item" :class="{'active' : itemsActive.includes(index)}">
        <div class="accordion__item__head" @click="setActive(index)">
          <div class="accordion__item__head__title" v-html="item.title"></div>
        </div>
        <div class="accordion__item__content" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<style src="./Accordion.scss" scoped></style>
<script>

export default {
  props: {
    single: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      baseData: [],
      itemsActive: []
    }
  },
  methods: {
    setActive (index) {
      let itemsActive = this.itemsActive;

      if (this.single) {
        itemsActive = itemsActive.includes(index) ? [] : [index];
      } else {
        if (itemsActive.includes(index)) {
          itemsActive.splice(itemsActive.indexOf(index), 1);
        } else {
          itemsActive.push(index);
        }
      }
      this.itemsActive = itemsActive;
    },
    makeData () {
      const $els = this.$refs.default.querySelectorAll('[accordion-item]');

      const baseData = [];

      $els.forEach(($el, index) => {
        const openAttr = $el.getAttribute('open')

        if (openAttr) {
          this.itemsActive.push(index)
        }

        baseData.push({
          title: $el.querySelector('[accordion-item-title]').innerHTML || '',
          content: $el.querySelector('[accordion-item-content]').innerHTML || ''
        })
      });

      this.baseData = baseData;
    }
  },
  mounted () {
    if (!this.baseData.length) {
      this.makeData();
    }
  }
}
</script>
